<template>
    <Dialog :visible="visible" :title="$t('shared.Reset connection')" @on-close="emits('onClose')">
        <template #content>
            <div class="q-mb-md">
                {{
                    $t(
                        "shared.There is already an active connection A new connection is created when resetting Previously connected devices are permanently disconnected"
                    )
                }}
            </div>
            <q-separator class="q-mb-md" />
            <div class="row justify-end">
                <qit-button color="secondary" class="q-mr-sm" :label="$t('shared.Cancel')" @click="emits('onClose')" />
                <qit-button color="destructive" :label="$t('shared.Reset connection')" @click="emits('onResetLink')" />
            </div>
        </template>
    </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/shared/components/dialog/dialog.vue";
import QitButton from "@/shared/components/buttons/qit-button.vue";

defineProps<{ visible: boolean }>();

const emits = defineEmits<{ onClose: []; onResetLink: [] }>();
</script>
